var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeader1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 224,
    height: 26,
    viewBox: "0 0 224 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62672",
    "data-name": "Group 62672",
    transform: "translate(-86 -251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16377",
    "data-name": "Rectangle 16377",
    transform: "translate(86 251)",
    fill: "#fff",
    stroke: "#d3d3d3",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 26,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.35,
    width: 223.3,
    height: 25.3,
    rx: 1.65,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-image",
    "data-name": "Icon awesome-image",
    d: "M18.372,19.1H1.9A1.864,1.864,0,0,1,0,17.272V6.325A1.864,1.864,0,0,1,1.9,4.5H18.372a1.864,1.864,0,0,1,1.9,1.825V17.272A1.864,1.864,0,0,1,18.372,19.1ZM4.435,6.629A2.174,2.174,0,0,0,2.217,8.757a2.174,2.174,0,0,0,2.217,2.129A2.174,2.174,0,0,0,6.652,8.757,2.174,2.174,0,0,0,4.435,6.629Zm-1.9,10.035h15.2V12.406L14.274,9.08a.489.489,0,0,0-.672,0L8.236,14.231l-2.2-2.11a.489.489,0,0,0-.672,0L2.534,14.839Z",
    transform: "translate(94.109 252.176)",
    fill: "#babec1"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Finacle_Reference_Number",
    "data-name": "Finacle Reference Number",
    transform: "translate(172 262)",
    fill: "#3e3e3e",
    fontSize: 5,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Finacle Reference Number")), /*#__PURE__*/React.createElement("text", {
    id: "_166616788",
    "data-name": 166616788,
    transform: "translate(172 270)",
    fontSize: 5,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "166616788")), /*#__PURE__*/React.createElement("g", {
    id: "Group_60117",
    "data-name": "Group 60117",
    transform: "translate(257.332 256.775)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Workstep_Name",
    "data-name": "Workstep Name",
    transform: "translate(-0.332 5.225)",
    fill: "#3e3e3e",
    fontSize: 5,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Workstep Name")), /*#__PURE__*/React.createElement("text", {
    id: "Draft",
    transform: "translate(-0.332 13.225)",
    fontSize: 5,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Draft"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader1);
export default __webpack_public_path__ + "static/media/header1.ed853b780caf536d83ce83f1d5f85f5b.svg";
export { ForwardRef as ReactComponent };